import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import Resource from "../resource";
import { PortalRowResource } from "./portal-row-resource";

@JsonObject()
export class PortalSectionResource extends Resource {
    @JsonProperty("name")
    name: string;

    @JsonProperty("rows")
    @JsonElementType(PortalRowResource)
    rows: Array<PortalRowResource> = [];
}
